module.exports = __webpack_public_path__ + "fonts/CircularStd-BlackItalic.0cda47fe.otf";